import { useState } from 'react';
import { record } from "@solimat/solimat-web-endpoint";

const useUpdatePagoUnicoCATAByID = () => {
  const [loadingUpdatePagoUnicoCATAById, setLoadingCreatePagoUnicoCATA] = useState(false);
  const [successUpdatePagoUnicoCATAById, setSuccessCreatePagoUnicoCATA] = useState(false);
  const [errorUpdatePagoUnicoCATAById, setErrorCreatePagoUnicoCATA] = useState(null);
  const [dataUpdatePagoUnicoCATAById, setDataPagoUnicoCATA] = useState(null);

  const BASE_URL = import.meta.env.VITE_REACT_APP_PRESTACIONES_PACIENTE_PATH || "";
  const FUNCTIONS_KEY = import.meta.env.VITE_REACT_APP_PRESTACIONES_PACIENTE_KEY || "";
  const apiRecord = new record.RecordService(
    BASE_URL,
    FUNCTIONS_KEY
  )


  //UPDATE
  const updatePagoUnicoCATAById = async (userId:string , formId: string, data:any, _cb?:(data:any)=>void) => {
    setLoadingCreatePagoUnicoCATA(true);
    setSuccessCreatePagoUnicoCATA(false);
    setErrorCreatePagoUnicoCATA(null);

    apiRecord.updateSolicitudPagoUnicoByID(userId, formId, data).then((res: any) => {
      setLoadingCreatePagoUnicoCATA(false);
      setSuccessCreatePagoUnicoCATA(true);
      setDataPagoUnicoCATA(res.data);
      if (typeof _cb === "function") {
        _cb(res.data);
      }

    }).catch((err:any) => {
      console.log(err)
      setLoadingCreatePagoUnicoCATA(false);
      setErrorCreatePagoUnicoCATA(err.response.data)
    })
  }

  return {
    updatePagoUnicoCATAById,
    loadingUpdatePagoUnicoCATAById,
    successUpdatePagoUnicoCATAById,
    errorUpdatePagoUnicoCATAById,
    dataUpdatePagoUnicoCATAById
  }

}

export default useUpdatePagoUnicoCATAByID;
